<template>
    <div>
        <div v-if="header" :id="'collapse-' + _uid" class="collapse" v-bind:class="show ? 'show' : ''" v-bind:data-parent="accordion ? accordion : ''">
             <div class="col-12 mb-0 mt-3 d-flex justify-content-between">
                <small class="ml-2 text-muted">Form name</small>
                <small class="mr-5 pr-2 text-muted">Use on project</small>
            </div>
        </div>
        <div class="flex-table flex-table--row--no-padding-x flex-table--row--no-padding-y">
            <a
                class="flex-table--row flex-table--row--no-padding-x no-link accordion-title"
                v-bind:class="{collapsed : !show, disable_line: no_table_line}"
                :href="'#collapse-' + _uid"
                role="button"
                data-toggle="collapse"
                :aria-expanded="show"
                :aria-controls="'collapse-' + _uid"
                v-on:mouseenter="hover = true"
                v-on:mouseleave="hover = false"
            >
                <div v-if="title" class="flex-table--header-title">
                    <h5>{{title}}</h5>
                </div>
                <div class="flex-table--header-content" v-bind:class="!title ? 'flex-table--cell-grow-always flex-table--row--no-padding-x flex-table--row--no-padding-y' : ''">
                    <slot name="header_content" />
                </div>
                <svg-image
                    :src="'/svg/' + resource_group + '/chevron-down.svg'"
                    class="accordion-icon flex-table--cell"
                    color="light-grey"
                    :hover="hover"
                />
            </a>

            <div :id="'collapse-' + _uid" class="collapse" v-bind:class="show ? 'show' : ''" v-bind:data-parent="accordion ? accordion : ''">
                <slot name="content" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Collapsable",
        props: {
            title: {
                type: String,
                default: ''
            },
            accordion: {
                type: String,
                default: null
            },
            show: {
                type: Boolean,
                default: false
            },
            no_table_line: {
                type: Boolean,
                default: false
            },
            header: {
                type: Boolean,
                default: false
            }
        },
        data (){
            return {
                hover: false
            }
        }
    }
</script>
